export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11359.02e80039.jpg";